import { render, staticRenderFns } from "./DetailedRepaletizaje.vue?vue&type=template&id=783de10b"
import script from "./DetailedRepaletizaje.vue?vue&type=script&lang=js"
export * from "./DetailedRepaletizaje.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports